import { Button } from "@newsela/angelou";
import { useRouter } from "next/router";
import PropTypes from "prop-types";

import { withTrackEvent, objectTypes, actionNames } from "@newsela/snitch";
import ChallengeCountdown from "@/challenges/ChallengeCountdown";
import ChallengeLearnMoreModal from "@/challenges/ChallengeLearnMoreModal/ChallengeLearnMoreModal";
import {
  container,
  heading,
  headerWrapper,
  contentWrapper,
  textWrapper,
  imageWrapper,
  imageCss,
} from "./ChallengeTeacherHomePage.style";

const propTypes = {
  expirationDate: PropTypes.any,
};

const ChallengeTeacherHomePage = ({ expirationDate }) => {
  const ButtonWithTrackEvent = withTrackEvent(Button);
  const router = useRouter();
  const month = expirationDate?.toLocaleString("en-GB", { month: "short" });
  const date = expirationDate?.getDate();
  const now = new Date();
  const countdown = Math.floor(
    (expirationDate?.getTime() - now?.getTime()) / (1000 * 3600 * 24),
  );
  const todayMonth = now?.toLocaleString("en-GB", { month: "long" });
  return (
    <div css={container}>
      <div css={headerWrapper}>
        <h2 css={heading}>
          {todayMonth.charAt(0).toUpperCase() + todayMonth.slice(1)} reading
          challenge
        </h2>
        <ChallengeCountdown month={month} date={date} countdown={countdown} />
      </div>
      <div css={contentWrapper}>
        <div css={textWrapper}>
          <h1>Promote independent reading</h1>
          <p>
            Each month, students can read articles that interest them and earn
            tokens for every quiz, Power Words and Guided Highlighting activity
            completed. Students earn a badge when they reach their monthly
            reading goal.
            <ChallengeLearnMoreModal />
          </p>
          <ButtonWithTrackEvent
            flavor={Button.flavors.primary}
            onClick={() => router.push("/challenges")}
            objectType={objectTypes.user}
            actionName={actionNames.navigate}
            streamProperties={{
              description: "Send Teacher to Challenges",
              project: "IRC",
            }}
          >
            View challenge
          </ButtonWithTrackEvent>
        </div>
        <div css={imageWrapper}>
          <img css={imageCss} />
        </div>
      </div>
    </div>
  );
};

ChallengeTeacherHomePage.propTypes = propTypes;

export default ChallengeTeacherHomePage;
